import { types } from 'mobx-state-tree';
import _ from 'lodash';
import { orderBy } from 'natural-orderby';

import BookmarkModel from 'app/state/models/BookmarkModel';

const BookmarkStore = types
  .model({
    collection: types.array(BookmarkModel),
  })
  .views(self => ({
    get groupedEntries() {
      let entries = _.groupBy(self.collection.slice(), entry =>
        JSON.stringify(
          _.chain(entry.path.slice())
            .drop(1)
            .reject(_.isInteger)
            .filter(el => el.match('chapter|section|introduction'))
            .map(_.capitalize)
            .value()
            .join(', ')
        )
      );
      entries = orderBy(
        _.toPairs(entries),
        [entry => JSON.stringify(entry[0])],
        ['asc']
      );

      entries = _.map(entries, entry => {
        let path = entry[0];
        let selections = entry[1];
        selections = _.map(selections, ({ path, content, note }) => ({
          path: path.slice(),
          content,
          note,
        }));
        return [path.slice(1, -1), selections];
      });

      return _.fromPairs(entries);
    },
  }))
  .actions(self => ({
    insert(bookmark) {
      self.collection.push(bookmark);
    },
    delete(path) {
      path = path.slice();
      const bookmark = self.collection.find(entry =>
        _.isEqual(entry.path.slice(), path)
      );
      if (bookmark) {
        self.collection.remove(bookmark);
      }
    },
    clearBookmarks() {
      self.collection = [];
    },
  }));

export default BookmarkStore;



// WEBPACK FOOTER //
// ./src/app/state/stores/BookmarkStore.js